(function(){
  // Find all c2t sections that have zoom enabled
  var sections = document.querySelectorAll('.ha-c2t.has-zoomfx');
  if(!sections.length) return;

  // Respect reduced motion globally
  var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(prefersReduced) return;

  sections.forEach(function(section){
    if(section.dataset.zoomfxInit === '1') return;
    section.dataset.zoomfxInit = '1';

    var imgs = section.querySelectorAll('.c2t__img');
    if(!imgs.length) return;

    // One-time play per image when it becomes visible
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(!entry.isIntersecting) return;
        var img = entry.target;

        if(img.dataset.zoomfxPlayed === '1'){ io.unobserve(img); return; }

        img.dataset.zoomfxPlayed = '1';
        img.classList.add('zoomfx-enter');

        img.addEventListener('animationend', function(){
          img.classList.remove('zoomfx-enter');
        }, { once: true });

        io.unobserve(img);
      });
    }, { threshold: [0, 0.25] });

    imgs.forEach(function(img){ io.observe(img); });
  });
})();